<carm-card *ngIf="links?.length > 0" class="carm-widget carm-most-requested-widget">
  <carm-card-title data-cy="most-requested-homepage-title">
    <span>{{'dashboard.widgets.most_requested.title' | translate }}</span>
  </carm-card-title>
  <carm-card-content>
    <div class="mrgn-tp-md mrgn-bttm-xl">
      <ul>
        <li class="spacing-larger" *ngFor="let link of links"><a
          class="font-larger"
          [carmRouterLink]="link.key"
          data-cy="most-requested-items">{{link.value}}</a></li>
      </ul>
    </div>
  </carm-card-content>
</carm-card>
